import { useContext } from 'react';
import { useStaticQuery } from 'gatsby';
import { LanguageContext } from '../providers';
export const useFooterData = () => {
  const {
    language
  } = useContext(LanguageContext);
  const {
    allDirectusWidgets
  } = useStaticQuery("2861181480");
  return {
    language,
    widgets: allDirectusWidgets.nodes
  };
};